import { MyFoodsMain, MyFoodsWrapper } from "./styled"
import { Outlet, useLocation } from "react-router-dom"
import TopNavigation from "./TopNavigation"
import { useFavoriteMeals } from "features/favoriteMeals/hooks/useFavoriteMeals"
import { FavoriteMealsContextType } from "../foodSlice.types"
import { useEffect, useRef } from "react"
import PATHS from "router/paths"
import { useAppDispatch, useAppSelector } from "app/hooks"
import { setFavoriteMealsScrollTop } from "features/favoriteMeals/favoriteMealsSlice"

const MyFoods = () => {
  const location = useLocation()
  const dispatch = useAppDispatch()

  const {
    favoriteMeals,
    loadMore,
    getFavoriteMealsLoading,
    isNoFavoriteMeals,
    hasMore,
  } = useFavoriteMeals()

  const favoriteMealsScrollTop = useAppSelector(
    (state) => state.favoriteMeals.favoriteMealsScrollTop,
  )
  const favoriteMealsContentRef = useRef<any>(null)

  // Restore scroll position when returning from FavoriteMealDetails
  useEffect(() => {
    if (
      location.pathname === PATHS.app.myFoods.root &&
      favoriteMealsContentRef.current &&
      favoriteMealsScrollTop > 0
    ) {
      favoriteMealsContentRef.current.scrollTop = favoriteMealsScrollTop
    }
  }, [location.pathname, favoriteMealsScrollTop])
  return (
    <MyFoodsWrapper
      style={
        {
          "--profile-header-height": "0px",
        } as React.CSSProperties
      }
    >
      <MyFoodsMain>
        <TopNavigation />
        <Outlet
          context={
            {
              favoriteMeals,
              getFavoriteMealsLoading,
              isNoFavoriteMeals,
              hasMoreFavoriteMeals: hasMore,
              loadMoreFavoriteMeals: loadMore,
              favoriteMealsContentRef,
              favoriteMealsScrollTop,
              setFavoriteMealsScrollTop: (scrollTop: number) =>
                dispatch(setFavoriteMealsScrollTop(scrollTop)),
            } satisfies FavoriteMealsContextType
          }
        />
      </MyFoodsMain>
    </MyFoodsWrapper>
  )
}

export default MyFoods
